// extracted by mini-css-extract-plugin
export default {"dashboardHeader":"DashboardHeader_dashboardHeader__EkvSe"};